import type { ItgConfig } from "@ceeferenderer/itg-renderer-sdk";
import { FetchClientProvider } from "../utils/FetchClientProvider";
import { loggingFetch } from "../utils/loggingFetch";

export const itgConfig: ItgConfig = {
  applicationName: "DSS2.0",
  cssApplicationName: "FESDK",
  encrypt: {
    iv: "101112131415161718191a1b1c1d1e1f",
    mode: "CTR",
    padding: "Iso10126",
    type: "DES",
  },
  isServiceProtected: false,
  restClientProvider: new FetchClientProvider(loggingFetch),

  /* these can not be full URIs, they can only be the path to that specific endpoint */
  startItgURI: "/ITGProcess",
  stepItgURI: "/ITGStep",
};
